import { Component } from '@angular/core';
import { Toast } from '../../types/toast';
import { ToastType } from '../../enums/toast-type';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  standalone: false,
})
export class ToastComponent {
  currentToast: Toast = {
    type: ToastType.success,
    message: '',
    isOpen: false,
    classes: '',
  };

  constructor(toastService: ToastService) {
    this.currentToast = toastService.toast;
  }

  close(): void {
    this.currentToast.isOpen = false;
  }
}
